import { alpha, Box } from '@mui/material';

import { StyledDialogContent, StyledEntityName } from '../styles';
import type { IConfirmDialogContentProps } from '../types';

export const ConfirmDialogContent = ({ dialogContent, typedContent, mainColor }: IConfirmDialogContentProps) => {
  const isTypedContent = typedContent !== undefined;

  const typedMessege = isTypedContent && (
    <Box>
      {typedContent?.description?.part1 ?? ''}
      <StyledEntityName component='span' sx={{ backgroundColor: alpha(mainColor.hex, 0.3) }}>
        <b> {typedContent?.entityName} </b>
      </StyledEntityName>
      {typedContent?.description?.part2 ?? ''}
      <br />
      {typedContent?.description?.part3 ?? ''}
    </Box>
  );

  return <StyledDialogContent>{dialogContent ?? typedMessege ?? ''}</StyledDialogContent>;
};
